const Prospect = {
  loggedInUser: {
    name: 'John Doe',
    email: 'john.doe@email.com',
    impersonated: false,
  },
  state: {
    step: 0,
    status: 'New',
  },
  contacts: [
    {
      contactType: null,
      name: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      postalCode: null,
      phone: null,
      fax: null,
      email: null,
    },
  ],
  officeLocations: [
    {
      address: null,
      city: null,
      state: null,
      zip: null,
    },
  ],
  bankInformation: {
    bankName: null,
    accountNumber: null,
    contactType: null,
    collectionExplanation: null,
    delinquencyExplanation: null,
  },
  taxPreparer: {
    firmName: null,
    contactType: null,
  },
  companyInfo: {
    ownerNames: null,
    legalName: null,
    legalNameAlt: null,
    descriptionOfOperations: null,
    ownerDOB: null,
    ssn: null,
    date: null,
    fedId: null,
    yearsAtLocation: null,
    yearsInBusiness: null,
    corporationType: null,
    employeeWorkStates: null,
    primaryContactType: null,
    ownerContactType: null,
  },
  payrollInformation: {
    employees: {
      fullTime: null,
      partTime: null,
      annualPayroll: null,
      payrollFrequency: null,
    },
    owners: {
      fullTime: null,
      partTime: null,
      annualPayroll: null,
      payrollFrequency: null,
    },
  },
  peo: {
    name: null,
    effectiveDate: null,
  },
  flags: {
    workingWithPEO: false,
    workersCompPolicy: false,
    workersCompInvoice: false,
    payrollRegister: false,
    stateUnemploymentReport: false,
    workersCompLossReports: false,
    officeLocations: false,
    usingPEOWorkersComp: false,
    hasBenefitPacket: false,
    hasCollections: false,
    hasDelinquency: false,
  },
  documents: [
    {
      name: null,
      category: null,
    },
  ],
};

export default Prospect;
